var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgMenuArrow = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.00008 11.3333C7.2637 11.3333 6.66675 11.9303 6.66675 12.6667C6.66675 13.403 7.2637 14 8.00008 14C8.73646 14 9.33341 13.403 9.33341 12.6667C9.33341 11.9303 8.73646 11.3333 8.00008 11.3333Z",
  fill: "white"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.00008 6.66667C7.2637 6.66667 6.66675 7.26362 6.66675 8C6.66675 8.73638 7.2637 9.33333 8.00008 9.33333C8.73646 9.33333 9.33341 8.73638 9.33341 8C9.33341 7.26362 8.73646 6.66667 8.00008 6.66667Z",
  fill: "white"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.00008 2C7.2637 2 6.66675 2.59695 6.66675 3.33333C6.66675 4.06971 7.2637 4.66667 8.00008 4.66667C8.73646 4.66667 9.33341 4.06971 9.33341 3.33333C9.33341 2.59695 8.73646 2 8.00008 2Z",
  fill: "white"
})));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMenuArrow, _extends({
  svgRef: ref
}, props)));
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04LjAwMDA4IDExLjMzMzNDNy4yNjM3IDExLjMzMzMgNi42NjY3NSAxMS45MzAzIDYuNjY2NzUgMTIuNjY2N0M2LjY2Njc1IDEzLjQwMyA3LjI2MzcgMTQgOC4wMDAwOCAxNEM4LjczNjQ2IDE0IDkuMzMzNDEgMTMuNDAzIDkuMzMzNDEgMTIuNjY2N0M5LjMzMzQxIDExLjkzMDMgOC43MzY0NiAxMS4zMzMzIDguMDAwMDggMTEuMzMzM1oiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNOC4wMDAwOCA2LjY2NjY3QzcuMjYzNyA2LjY2NjY3IDYuNjY2NzUgNy4yNjM2MiA2LjY2Njc1IDhDNi42NjY3NSA4LjczNjM4IDcuMjYzNyA5LjMzMzMzIDguMDAwMDggOS4zMzMzM0M4LjczNjQ2IDkuMzMzMzMgOS4zMzM0MSA4LjczNjM4IDkuMzMzNDEgOEM5LjMzMzQxIDcuMjYzNjIgOC43MzY0NiA2LjY2NjY3IDguMDAwMDggNi42NjY2N1oiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNOC4wMDAwOCAyQzcuMjYzNyAyIDYuNjY2NzUgMi41OTY5NSA2LjY2Njc1IDMuMzMzMzNDNi42NjY3NSA0LjA2OTcxIDcuMjYzNyA0LjY2NjY3IDguMDAwMDggNC42NjY2N0M4LjczNjQ2IDQuNjY2NjcgOS4zMzM0MSA0LjA2OTcxIDkuMzMzNDEgMy4zMzMzM0M5LjMzMzQxIDIuNTk2OTUgOC43MzY0NiAyIDguMDAwMDggMloiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };